import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute} from "@angular/router"

// import { TranslateService } from '@ngx-translate/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { MatDialog ,MatDialogRef} from "@angular/material/dialog";
import * as $ from 'jquery';
import { AboutUSComponent } from '../Modal/about-us/about-us.component'
import { ProductComponent } from '../Modal/product/product.component'
import { CSRComponent } from '../Modal/csr/csr.component'
import { AuthService } from '../../services/auth.service';
import { FrontSideComponent } from './../front-side/front-side.component';
import { BusinessPolicyComponent } from '../Modal/business-policy/business-policy.component';
import { CSRPolicyComponent } from '../Modal/csrpolicy/csrpolicy.component';
import { MGTComponent } from '../Modal/mgt/mgt.component';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['../../../../../node_modules/bootstrap3/dist/css/bootstrap.min.css','./home.component.css']
})
export class HomeComponent implements OnInit {

  decodeHelper = new JwtHelperService();
  decodedTkn = this.decodeHelper.decodeToken(localStorage.getItem('access_token'));

  LoginShw:boolean=false

  constructor(
    // private translate: TranslateService,
    private router: Router,
    public dialog: MatDialog,
    private authServObj:AuthService,
    private route: Router,
    private activatedRoute : ActivatedRoute
    ) {
    localStorage.setItem("lang",'en')
    // translate.setDefaultLang(localStorage.getItem('lang'));
  }


  ngOnInit(): void {
    window.addEventListener("scroll", this.reveal);


 

    this.activatedRoute.paramMap.subscribe(params => {
      if(params.get('pagetype') == "webregistration"){
        this.LoginShw = true
      }
    })

    this.loadScript();

    if(this.decodedTkn && this.decodedTkn.Cat){
      if(this.decodedTkn.Cat=='U'){
        this.router.navigateByUrl('/userpanel');
      }else{
        this.router.navigateByUrl('/adminpanel');
      }
    }


    $(document).on('scroll', function() {
      var scrollPosition = window.pageYOffset;
      var zoomLevel = Math.min(2, 1 + scrollPosition / 500);
    
      var zoomText = $('#zoom-text');
      zoomText.css('transform', 'translate(-50%, -50%) scale(' + zoomLevel + ')');
    });



    $(function () {
      var link = $('.border_row a.bo_menu ');

      link.on('click', function (e) {
        $('.bo_menu').removeClass('active');
        var target = $($(this).attr('href'));
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 600);
        $(this).addClass('active');
        e.preventDefault();
      });

      $(window).on('scroll', function () {
        scrNav();
      });

      function scrNav() {
        var sTop = $(window).scrollTop();
        $('.section').each(function () {
          var id = $(this).attr('id'),
            offset = $(this).offset().top - 1,
            height = $(this).height();
          if (sTop >= offset && sTop < offset + height) {
            link.removeClass('active');
            $('.border_row').find('[data-scroll="' + id + '"]').addClass('active');
          }
        });
      }

      scrNav();
    });


    var btn = $('#button');

    btn.on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({scrollTop: 0}, '300');
    });

    this.authServObj.GetBannerDetail({PAGENAME:'HOMEPOPUP'}).subscribe(FrontSideRes => {
      try{
        if(FrontSideRes.success == true && FrontSideRes.data.length != 0){
          if(FrontSideRes.data[0].URL_TYPE.toUpperCase() == "MP4" || FrontSideRes.data[0].URL_TYPE.toUpperCase() == "MOV"){
            this.OpenDetailModal('Video',FrontSideRes.data[0].URL,FrontSideRes.data[0].ISDONTCLOSE)
          }else if(FrontSideRes.data[0].URL_TYPE.toUpperCase() == "PNG" || FrontSideRes.data[0].URL_TYPE.toUpperCase() == "JPG" || FrontSideRes.data[0].URL_TYPE.toUpperCase() == "JPEG" ){
            this.OpenDetailModal('Img',FrontSideRes.data[0].URL,FrontSideRes.data[0].ISDONTCLOSE)
          }else if(FrontSideRes.data[0].URL_TYPE.toUpperCase() == "TXT"){
            this.OpenDetailModal('TXT',FrontSideRes.data[0].POPUPMESSAGE,FrontSideRes.data[0].ISDONTCLOSE)
          }
        }
      }catch(err){
        console.log("err",err)
      }
    })

  }

  public loadScript() {
    let body = <HTMLDivElement> document.body;
    let script = document.createElement('script');

    script.innerHTML = '';
    script.src = 'assets/js/bootstrap.min.js';
    script.async = true;
    script.defer = true;
    body.appendChild(script);



  }

  reveal() {
    var reveals = document.querySelectorAll(".reveal");
    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = 10;
      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add("active");
      } else {
        reveals[i].classList.remove("active");
      }
    }
  }

  switchLanguage(language: string) {
    // this.translate.use(language);
    localStorage.setItem("lang",language)
  }

  OpenAboutUS(){
    const ABUS = this.dialog.open(AboutUSComponent,{width:'80%',height:'80%'});
  }

  OpenProduct(){

    const PRO = this.dialog.open(ProductComponent,{width:'80%',height:'80%'});
  }

  OpenCSR(){
    const PRO = this.dialog.open(CSRComponent,{width:'80%',height:'80%'});
  }

  OpenBusPol() {
    const PRO = this.dialog.open(BusinessPolicyComponent,{width:'80%',height:'80%'});
  }

  OpenCSRPol() {
    const PRO = this.dialog.open(CSRPolicyComponent,{width:'80%',height:'80%'});
  }


  OpenMGT(DocName:string){
    const MGT = this.dialog.open(MGTComponent,{width:'80%',height:'80%', data: {DocName}});
  }

  matDialogRefDteails: MatDialogRef<FrontSideComponent>;
  OpenDetailModal(ModalTopic,FilePath,DontClose) {
    this.matDialogRefDteails = this.dialog.open(FrontSideComponent, {data: {ModalTopic,FilePath,DontClose}, disableClose: true,width:'auto'});
  }

  ReSetUrl(){
    this.router.navigate(['/'])
  }
}


